import {Accordion, AccordionDetails, AccordionShortDetails, AccordionTitle} from 'components';
import {AuthSource} from 'enums';

import {Actions, IntegrationContent, IntegrationDescription, SourceLabel} from '../IntegrationContent';

type Props = {
    integration: {
        source: AuthSource;
        credentials: any;
        data: any;
    };
    logo: string;
    sourceLabel: string;
    isEditable: boolean;
    isSalesforceIntegration: boolean;
    isDeviceIntegration: boolean;
    isAppointmentsIntegration: boolean;
    onEdit: () => void;
    onDelete: () => void;
};

export const IntegrationsAccordion: React.FC<Props> = ({
    integration, sourceLabel, logo, isEditable, isSalesforceIntegration, isDeviceIntegration, isAppointmentsIntegration, onEdit, onDelete
}: Props) => (
    <Accordion className='tw-mb-2 sm:tw-hidden'>
        <AccordionTitle>
            <div className='tw-flex tw-items-center -sm:tw-my-1'>
                <div className='tw-w-9 tw-mr-2 tw-flex-shrink-0'>
                    <img src={logo} alt={sourceLabel} className='tw-w-full' />
                </div>
                <SourceLabel label={sourceLabel} />
                <Actions isEditable={isEditable} onEdit={onEdit} onDelete={onDelete} />
            </div>
        </AccordionTitle>
        <AccordionShortDetails>
            <IntegrationDescription source={integration.source} />
        </AccordionShortDetails>
        <AccordionDetails>
            <IntegrationContent
                integration={integration}
                isSalesforceIntegration={isSalesforceIntegration}
                isDeviceIntegration={isDeviceIntegration}
                isAppointmentsIntegration={isAppointmentsIntegration}
            />
        </AccordionDetails>
    </Accordion>
);